<div mat-dialog-content>
  {{ _data.data }}
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>
    {{ "ERROR_DIALOG.ACTION_BUTTON" | translate }}
  </button>
</div>
